/** @format */

import React, { FC, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Form, FormItem, Button, Select, Option, _$ } from '@king-design/react'
// import { Select, Option } from '@king-design/react'
import { SearchValuesProps } from './index'

interface DataSourceProps {
  className?: string
  sourceOptions: any[]
  fabricOptions: any[]
  deviceOptions: any[]
  allnode_loading: boolean
  formValues: SearchValuesProps
  setFormValues: (values: SearchValuesProps) => void
}

const DataSource: FC<DataSourceProps> = ({
  className,
  sourceOptions,
  fabricOptions,
  deviceOptions,
  allnode_loading,
  formValues,
  setFormValues
}) => {
  const [device, setDevice] = useState<string[]>([])
  useEffect(() => {
    setDevice(formValues.device)
  }, [formValues.device])

  return (
    <Form className={className} layout="inline">
      <FormItem label={_$('数据源')}>
        <Select
          width={150}
          value={formValues.dataSource}
          onChangeValue={value => {
            setFormValues({
              ...formValues,
              dataSource: value,
              device: []
            })
          }}
        >
          {sourceOptions?.length
            ? sourceOptions.map(({ ClusterID, ClusterName }) => (
                <Option key={ClusterID} value={ClusterID}>
                  {ClusterName}
                </Option>
              ))
            : null}
        </Select>
      </FormItem>
      <FormItem className="fabric-form-item" label="Fabric">
        <Select
          width={150}
          value={formValues.fabric}
          filterable
          onChangeValue={value => {
            setFormValues({
              ...formValues,
              fabric: value
            })
          }}
        >
          {fabricOptions?.map(({ FabricName, FabricID }) => (
            <Option key={FabricID} value={FabricID}>
              {FabricName}
            </Option>
          ))}
        </Select>
      </FormItem>
      <FormItem className="device-form-item" label={_$('设备')}>
        <Select
          className="king-select"
          value={allnode_loading ? [] : device}
          width={400}
          multiple
          nowrap
          filterable
          clearable
          // nowrap
          container={() => document.getElementsByClassName('device-form-item')[0]}
          loading={allnode_loading}
          onChangeValue={value => {
            setDevice(value)
          }}
        >
          {deviceOptions?.map(({ DN, NeName }) => (
            <Option key={DN} value={DN}>
              {NeName}
            </Option>
          ))}
        </Select>
      </FormItem>
      <FormItem hideLabel>
        <Button
          type="primary"
          onClick={() => {
            setFormValues({
              ...formValues,
              device
            })
          }}
        >
          {_$('查询')}
        </Button>
        <Button
          onClick={() => {
            setDevice([])
            setFormValues({
              ...formValues,
              device: []
            })
          }}
        >
          {_$('重置')}
        </Button>
      </FormItem>
    </Form>
  )
}

export default styled(DataSource)`
  padding: 16px 0 0;
  .k-form-item {
    margin-bottom: 0px;
  }
  .k-btn.k-primary {
    margin-right: 8px;
  }
  /* 设备options 告警状态 */
  /* .device-form-item {
    .k-dropdown-menu {
      .k-item {
        &::before {
          content: '';
          display: inline-block;
          width: 8px;
          height: 8px;
          margin-right: 8px;
          border-radius: 50%;
          background-color: red;
        }
      }
    }
  } */
`
